module.exports = __webpack_public_path__ + "img/leftDownZj.beaf235f.png";